import React from "react";
import { faChartLine } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import "./styles/works.css";

const Works = () => {
	return (
		<div className="works">
			<Card
				icon={faChartLine}
				title="Key Metrics"
				body={
					<div className="works-body">
						<div className="work">
							<div className="work-title">60+</div>
							<div className="work-subtitle">
								Projects Delivered
							</div>
						</div>

						<div className="work">
							<div className="work-title">5+</div>
							<div className="work-subtitle">
								Years Experience
							</div>
						</div>

						<div className="work">
							<div className="work-title">97%</div>
							<div className="work-subtitle">
								Client Satisfaction
							</div>
						</div>
					</div>
				}
			/>
		</div>
	);
};

export default Works;
